import { useState, useEffect } from 'react'
import { cx } from '@/utils/strings'
import BwiClose from '@/icons/bwi/close.svg'
import { usePage } from '@inertiajs/react'
import HubspotForm from '@/components/ui/hubspot-form'
import Collapsible from '@/components/ui/collapsible'
import { TypeComponentHubSpotForm } from '@/types/ctf'

interface Props {
  form: TypeComponentHubSpotForm<'WITHOUT_UNRESOLVABLE_LINKS'>
}

export default function PageSuggestions({ form }: Props) {
  const [isOpen, setIsOpen] = useState(false)
  const page = usePage()

  useEffect(() => {
    if (isOpen) {
      const frm = document.getElementById('help-page-suggestions') as HTMLFormElement
      frm.scrollIntoView({ behavior: 'smooth' })
    }
    document.querySelectorAll('.hs_form_path')?.forEach((el) => {
      el.querySelector('input[type="hidden"]')?.setAttribute('value', page.url)
    })
  }, [isOpen])

  return (
    <div className={cx('rounded-2xl p-4 bg-secondary-50 relative dark:bg-secondary-900', isOpen && 'dark:bg-white')}>
      <div className="w-full flex">
        <button
          type="button"
          className={cx(
            'bg-white rounded-xl text-primaryBlue dark:text-white self-end ml-auto h-auto py-2 whitespace-normal hover:bg-secondary-100 transition-colors dark:bg-secondary-900 dark:hover:text-secondary-800',
            isOpen ? 'w-auto z-[2]' : 'w-full'
          )}
          onClick={() => {
            window.location.hash = 'help-page-suggestions'
            setIsOpen(!isOpen)
          }}
        >
          {isOpen ? (
            <BwiClose className="absolute right-10 top-10 h-5 w-5 mx-2 my-0 dark:text-indigoBlue" />
          ) : (
            form?.fields?.headline
          )}
        </button>
      </div>
      <div
        id="help-page-suggestions"
        className={`${isOpen ? '[&_button]:block p-3 lg:p-8' : '[&_button]:hidden'} dark:text-indigoBlue dark:[&_a]:text-primaryBlue dark:hover:[&_a]:text-primaryBlue`}
      >
        <Collapsible className="text-sm overflow-hidden" isOpen={isOpen}>
          <HubspotForm {...form.fields} />
        </Collapsible>
      </div>
    </div>
  )
}
